import { toast } from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useDeleteStandardException = ({ onSuccess } = {}) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError(
    "Error while deleting standard exception"
  );

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (exceptionId) => {
      const axiosInstance = await createAxiosInstance();
      await axiosInstance.delete(
        `${tenantVal}/schedule-exceptions/${exceptionId}`
      );
    },
    onSuccess: () => {
      toast.success("Standard exception deleted successfully.");
      queryClient.invalidateQueries({ queryKey: ["appointments"] });
      queryClient.invalidateQueries({ queryKey: ["monthSlotCounts"] });
      onSuccess?.();
    },
    meta: { skipGlobalError: true },
    onError: handleNetworkError,
  });
};
